import { render } from "./TeamSettings.vue?vue&type=template&id=6562497b&scoped=true"
import script from "./TeamSettings.vue?vue&type=script&lang=js"
export * from "./TeamSettings.vue?vue&type=script&lang=js"

import "./TeamSettings.vue?vue&type=style&index=0&id=6562497b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6562497b"]])

export default __exports__